// extracted by mini-css-extract-plugin
module.exports = {"underConstruction":"UnderConstruction_underConstruction__11u-v","underConstructionContent":"UnderConstruction_underConstructionContent__2mClO"};